module.exports = __webpack_public_path__ + "images/bannerIT-5ac1df82e32fe8c7070d5bc260a480e0.jpg";